import useSWR, { SWRResponse } from 'swr';
import type { AxiosError } from 'axios';
import { Agent, IndividualGoal } from '../../../providers/api/dtos';
import { getIndividualGoalByAgentId } from '../../../providers/api/goal/goalProvider';

export const INDIVIDUAL_GOAL_V1_RID = '/v1/goals/individual/:agentId';

export default function useIndividualGoal(agentId?: Agent['id']): SWRResponse<IndividualGoal, AxiosError> {
  return useSWR(agentId ? [INDIVIDUAL_GOAL_V1_RID, agentId] : null, () => getIndividualGoalByAgentId(agentId!));
}
